(function() {
  "use strict";

  angular.module("SignInProfileProperties")


    .controller("SignInProfilePropertiesController", [
      '$scope', '$routeParams', 'currentTenant', 'EventHandlerService',
      '$http', 'URL_PARAMS', 'GoProfileModel', '$rootScope', 'PrinterListPOSTPaging',
      '$timeout', '$location', 'OnDeviceConfigService', 'toastr', '$filter',
      function(
        $scope, $routeParams, currentTenant, EventHandlerService,
        $http, URL_PARAMS, GoProfileModel, $rootScope, PrinterListPOSTPaging,
        $timeout, $location, OnDeviceConfigService, toastr, $filter
        ) {

        $scope.tenant = currentTenant;
        $scope.me = null;
        $scope.eventHandlerService = EventHandlerService;
        $scope.refresh = 0;
        $scope.goProfile = null;
        $scope.thresholdToSwitchCreatedTimeFormat = 6;

        $scope.pageMetaData = new PrinterListPOSTPaging();
        $scope.helpCaption = 'HelpSignInProfilePage';
        $scope.foreignScope = null;
        $scope.onDeviceConfig = null;
        $scope.editMode = false;

        (function(){
          initEventHandler();
          getGoProfile();
        })();

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        function getGoProfile () {
          var signInProfileId = $routeParams[URL_PARAMS.SIGN_IN_PROFILE_ID.ROUTE];
          var url = $scope.tenant.info._links['px:printerCredentials'].href + '/' + signInProfileId;
          $http.get(url).then(function(response) {
            $scope.goProfile = new GoProfileModel(response.data);
            getPrintersFirstPage();
          }).catch(function(error){});
        }

        function getPrintersFirstPage () {
          $scope.pageMetaData.pagingCriteria.pageSize = 1;
          $scope.goProfile.getPrinters($scope.pageMetaData).then(function(printerListObject) {
            $scope.totalPrinters = printerListObject.page.totalElements;
          }).catch(function(error){
            $scope.totalPrinters = null;
          });
        }

        $scope.$watch(function () {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
          }
        })

        $scope.editGoProfile = function () {
          $scope.editMode = !$scope.editMode;
        }

        $scope.verifySignInProfileOnPrinters = function () {
          $scope.goProfile.testPrinters().then(function(response) {
            toastr.success($filter('translate')('OK'))
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'))
          });
        }


        $scope.openGoProfileMenu = function(event) {
          $scope.closeAllMenues();
          $timeout(function () {
            $scope.menuContent = {
              menuItems: [
                {
                  title: 'AssignToPrinters', name: $scope.goProfile.info.name, selected: false, type: 'assignSignInProfileToPrinters', breaker: true,
                  disabled: $scope.me.isSystemObserver()
                },
                {
                  title: 'DeleteSignInProfile', name: $scope.goProfile.info.name, selected: false, type: 'deleteSignInProfile', breaker: true,
                  disabled: ($scope.totalPrinters > 0 ? true : false) || $scope.me.isSystemObserver()
                },
                {
                  title: 'SignInProfiles', name: $scope.goProfile.info.name, selected: false, type: 'link', breaker: true,
                  href: '/admin/#/settings?settingsSection=printixGo'
                },
              ],
              context: $scope.goProfile,
              icon: 'icon-key-card2ai',
              sizeClass: 'size125',
              type: 'ALLROUND',
            }
            $scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        $scope.openContextMenu = function (selectedContextMenuItem, contextPosition, menu) {
          $scope.closeAllMenues();

          if (selectedContextMenuItem.name) {
            selectedContextMenuItem.title = selectedContextMenuItem.name;
          }


          $timeout(function  () {
            $scope.selectedContextMenuItem = selectedContextMenuItem;
            $scope.contextPosition = contextPosition;
            $scope.context = menu ? menu.context : null;
            $scope.auxiliaries = {
              tenant: $scope.tenant,
              goProfile: $scope.goProfile
            }
            $scope.resource = $scope.tenant;
          }, 50)
        }


        $scope.closeAllMenues = function () {
          $scope.foreignScope = null;
          $scope.selectedContextMenuItem  =  null;
          $scope.contextPosition = null;
          $scope.context = null;
          $scope.menuContent = null;
          $scope.menuSpecs = null;
        }


        $scope.updateResources = function () {
          // $rootScope.$broadcast('REFRESH_GO_PRINTER_LIST');
          // getOnDeviceConfig();
        }


      }
    ]);
})();